import { Box, Button, Typography } from "@jewlr/storybook/core"
import { Modal } from "@jewlr/storybook/modal"
import PropTypes from "prop-types"
import React from "react"

const CorporateModal = ({ showCorporateModal, toggleCorporateModal }) => {
  return (
    <Modal
      height="fit-content"
      label="Your message has been sent!"
      onClose={() => {
        toggleCorporateModal(false)
      }}
      show={showCorporateModal}
      width="600px"
    >
      <Box textAlign="center">
        <Typography mb={3}>
          Thanks for your message! Someone will be in touch with you soon{" "}
        </Typography>
        <Button
          onClick={() => {
            toggleCorporateModal(false)
          }}
          variant="primary"
          width="200px"
        >
          Done
        </Button>
      </Box>
    </Modal>
  )
}

CorporateModal.propTypes = {
  showCorporateModal: PropTypes.bool,
  toggleCorporateModal: PropTypes.func,
}

export default CorporateModal
